import { AfterViewInit, Component, ElementRef, EventEmitter, Input, NgZone, Output, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { fromEvent, Subscription } from 'rxjs';
import { SessionTimeoutType } from '../../enums/session-timeout-type.enum';

@Component({
	selector: 'cfe-session-timeout',
	templateUrl: './session-timeout.component.html',
	styleUrls: ['./session-timeout.component.scss']
})
export class SessionTimeoutComponent implements AfterViewInit {
	// =======================================================================================================================================
	// Inputs
	// =======================================================================================================================================

	@Input() sessionTimeOutInSeconds: number;
	@Input() secondsRemaining: number;
	@Output() modalResult: EventEmitter<string> = new EventEmitter<string>();

	public modal: NgbModalRef;

	@ViewChild('sessionTimeoutModal', { static: true }) modalElementRef: ElementRef;

	public _lastAction = Date.now();
	public interval: any;
	public remaining: any;
	public maxRemaining: number;
	public maxInactive: number;

	constructor(private modalService: NgbModal, private ngZone: NgZone) {}

	// -----------------------------------------------------------------------------------------------------------------
	// Lifecycle hooks
	// -----------------------------------------------------------------------------------------------------------------

	/**
	 * Lifecycle hook AfterViewInit
	 */
	ngAfterViewInit() {
		// save maxRemaining time, because it will be reduced by interval
		this.maxRemaining = this.secondsRemaining;
		this.maxInactive = this.sessionTimeOutInSeconds;

		this.check();
		this.update();
	}

	public check() {
		// refresh timer
		if (this.interval) {
			clearTimeout(this.interval);
		}

		this.interval = setTimeout(() => {
			const logoutDate = this._lastAction + this.sessionTimeOutInSeconds * 1000;
			if (logoutDate - Date.now() < 0) {
				this.showModal();
			}
		}, this.sessionTimeOutInSeconds * 1000);
	}

	public showModal() {
		if (this.modal) {
			this.modal.close();
		}

		// delete Timer
		clearTimeout(this.interval);

		// reset counter
		this.secondsRemaining = this.maxRemaining;

		this.remaining = setInterval(() => {
			if (this.secondsRemaining <= 0) {
				this.closeModal(SessionTimeoutType.IGNORED);
				clearInterval(this.remaining);
			}
			this.secondsRemaining -= 1;
		}, 1000);

		// Open new modal
		this.ngZone.run(() => {
			this.modal = this.modalService.open(this.modalElementRef, { windowClass: 'modalview-confirm d-flex align-items-center' });
			this.modal.result.then(
				() => {
					this.closeModal(SessionTimeoutType.KEEP);
					clearInterval(this.remaining);
				},
				() => {
					this.closeModal(SessionTimeoutType.LOGOUT);
					clearInterval(this.remaining);
				}
			);
		});
	}

	private closeModal(state: string) {
		this.modal.close();
		this.modalResult.emit(state);
	}

	/**
	 * Updates "lastAction" when mouse moved
	 */
	public update(): Subscription {
		this._lastAction = Date.now();
		return fromEvent(document, 'mousemove').subscribe(() => {
			this._lastAction = Date.now();
			this.check();
		});
	}

	// Round
	public round(num: number) {
		return Math.round(num / 60) > 0 ? Math.round(num / 60) : 1;
	}
}
